import { postRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function autoScheduleRequest(options) {
	let url = orderTemplates.autoSchedulePath();
	await postRequest(url, {}, options);
}